import { NgIf } from '@angular/common';
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { FieldWrapper } from '@ngx-formly/core';
import { FormComponent } from '../../form.component';

/**
 * Mat Expansion Panel Wrapper Component
 *
 * Custom Template Options:
 * @prop  sectionsOpened: string[] (optional) - Array of section names that should be currently expanded.
 * @prop  headerFields: any[] (optional) - Array of fields to be displayed in the panel header.
 * @prop  headerModel: any (optional) - Model for the header fields.
 * @prop  onPanelAfterViewInit: (panel: any, fcPanelHeader: any) => void (optional) - Callback function after the view initializes.
 * @prop  onPanelHeaderEvent: (event: MouseEvent, panel: any) => void (optional) - Callback function for header click events that occur on the embedded sl-form.
 * @prop  onPanelOpenClose: (panel: any, fcPanelHeader: any) => void (optional) - Callback function for panel open/close events.
 * @prop  class: string (optional) - CSS class to apply to the panel header.
 * @prop  section: string (optional) - Section name for the panel, used to determine if it should be expanded.
 *
 */

@Component({
	selector: 'mat-expansion-panel-wrapper',
	template: `
		<mat-expansion-panel #panel [expanded]="isExpanded(props.section)" (afterExpand)="onPanelOpened()" (afterCollapse)="onPanelClosed()">
			<mat-expansion-panel-header [class]="props.class">
				<sl-form
					#fcPanelHeader
					*ngIf="props.headerFields"
					[model]="props?.headerModel"
					[fields]="props.headerFields"
					(click)="onPanelHeaderClick($event)"
					(keydown)="onPanelHeaderKeydown($event)"
				></sl-form>
			</mat-expansion-panel-header>
			<ng-container #fieldComponent></ng-container>
		</mat-expansion-panel>
	`,
	standalone: true,
	imports: [MatExpansionModule, NgIf, FormComponent],
})
export class MatExpansionPanelWrapperComponent extends FieldWrapper implements AfterViewInit {
	@ViewChild('panel') panel: any;
	@ViewChild('fcPanelHeader') fcPanelHeader: any;

	ngAfterViewInit(): void {
		if (this.props.onPanelAfterViewInit) {
			this.props.onPanelAfterViewInit(this.panel, this.fcPanelHeader);
		}
	}

	isExpanded(section: string): boolean {
		return Array.isArray(this.props.sectionsOpened) && this.props.sectionsOpened.includes(section);
	}

	onPanelHeaderClick(event: MouseEvent): void {
		if (this.panel && this.props.onPanelHeaderEvent) {
			this.props.onPanelHeaderEvent(event, this.panel);
		}
	}

	onPanelHeaderKeydown(event: KeyboardEvent): void {
		if (this.panel && this.props.onPanelHeaderEvent) {
			this.props.onPanelHeaderEvent(event, this.panel);
		}
	}

	onPanelOpened(): void {
		if (this.panel && this.props.onPanelOpenClose) {
			this.props.onPanelOpenClose(this.panel, this.fcPanelHeader);
		}
	}

	onPanelClosed(): void {
		if (this.panel && this.props.onPanelOpenClose) {
			this.props.onPanelOpenClose(this.panel, this.fcPanelHeader);
		}
	}
}
